import axios from "axios";
import { API_BASE_URL } from "./config";
import { unwrapResponse } from "./unpack";

const client = axios.create({ baseURL: API_BASE_URL });

/**
 * @param {string} path
 * @param {Record<string, unknown>} [body]
 */
export async function postPosterJson(path, body) {
  const { data: raw } = await client.post(path, body, {
    headers: { "Content-Type": "application/json" },
  });
  return unwrapResponse(raw);
}

/**
 * POST /api/auth
 * @param {string} code
 */
export async function posterAuth(code) {
  return postPosterJson("/api/auth", { code });
}

/**
 * @param {string} token
 */
export async function posterGetSettings(token) {
  return postPosterJson("/api/settings", { token });
}

/**
 * @param {string} token
 */
export async function posterListSpots(token) {
  return postPosterJson("/api/spots", { token });
}

/**
 * @param {string} token
 */
export async function posterListTablets(token) {
  return postPosterJson("/api/tablets", { token });
}

/**
 * @param {string} token
 */
export async function posterGetProducts(token) {
  return postPosterJson("/api/products", { token });
}
